import React from "react";
import { Card, CardHeader, CardContent, Divider, Box } from "@mui/material";

const ActionCard = ({ title, children, sx = {} }) => {
  return (
    <Card
      elevation={0}
      sx={{
        borderRadius: "12px",
        border: "1px solid #e2e8f0",
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.05)",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        ...sx,
      }}
    >
      <CardHeader
        title={title}
        titleTypographyProps={{
          fontSize: "1.05rem",
          fontWeight: 600,
          color: "#0f172a",
          m: 0,
        }}
        sx={{
          backgroundColor: "#ffffff",
          padding: "16px 20px",
        }}
      />
      <Divider sx={{ borderColor: "#e2e8f0" }} />
      <CardContent sx={{ padding: "20px", flexGrow: 1 }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "12px",
            flexWrap: "wrap",
          }}
        >
          {children}
        </Box>
      </CardContent>
    </Card>
  );
};

export default ActionCard;
